export default "__VITE_ASSET__VrP9LhCD__"